import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.scss';

const Stat = (props) => {
  const {
    value,
    label,
    type,
    wrapperClassName,
    labelClassName,
    valueClassName,
    labelAfterValue
  } = props;

  const labelElement = (
    <span className={`${styles.statLabel} ${labelClassName || ''}`}>
      {label}
    </span>
  );

  const wrapperClasses = `${styles.stat} ${styles[type] || ''} ${
    wrapperClassName || ''
  }`;

  return (
    <div className={wrapperClasses}>
      {!labelAfterValue && labelElement}
      <div className={`${styles.statValue} ${valueClassName || ''}`}>
        {value}
      </div>
      {labelAfterValue && labelElement}
    </div>
  );
};

Stat.TYPES = ['stat-xs', 'stat-sm', 'stat-lg', 'stat-xl'];

Stat.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element
  ]).isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Stat.TYPES),
  wrapperClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  valueClassName: PropTypes.string,
  labelAfterValue: PropTypes.bool
};

Stat.defaultProps = {
  type: null,
  wrapperClassName: null,
  labelClassName: null,
  valueClassName: null,
  labelAfterValue: false
};

export default Stat;
